var __defProp = Object.defineProperty,
  __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty,
  __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value
  }) : obj[key] = value,
  __spreadValues = (a, b) => {
    for (var prop in b || (b = {})) __hasOwnProp.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) __propIsEnum.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    return a;
  },
  __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) __hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0 && (target[prop] = source[prop]);
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop) && (target[prop] = source[prop]);
  return target;
};
import * as React6 from "react";
import { Button } from "@twilio-paste/button";
import { CloseIcon } from "@twilio-paste/icons/esm/CloseIcon";
import { ErrorIcon } from "@twilio-paste/icons/esm/ErrorIcon";
import { NeutralIcon } from "@twilio-paste/icons/esm/NeutralIcon";
import { SuccessIcon } from "@twilio-paste/icons/esm/SuccessIcon";
import { WarningIcon } from "@twilio-paste/icons/esm/WarningIcon";
import { MediaObject, MediaFigure, MediaBody } from "@twilio-paste/media-object";
import * as React from "react";
import { Box } from "@twilio-paste/box";
var __defProp2 = Object.defineProperty,
  __defProps2 = Object.defineProperties,
  __getOwnPropDescs2 = Object.getOwnPropertyDescriptors,
  __getOwnPropSymbols2 = Object.getOwnPropertySymbols,
  __hasOwnProp2 = Object.prototype.hasOwnProperty,
  __propIsEnum2 = Object.prototype.propertyIsEnumerable,
  __defNormalProp2 = (obj, key, value) => key in obj ? __defProp2(obj, key, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value
  }) : obj[key] = value,
  __spreadValues2 = (a, b) => {
    for (var prop in b || (b = {})) __hasOwnProp2.call(b, prop) && __defNormalProp2(a, prop, b[prop]);
    if (__getOwnPropSymbols2) for (var prop of __getOwnPropSymbols2(b)) __propIsEnum2.call(b, prop) && __defNormalProp2(a, prop, b[prop]);
    return a;
  },
  __spreadProps2 = (a, b) => __defProps2(a, __getOwnPropDescs2(b)),
  __objRest2 = (source, exclude) => {
    var target = {};
    for (var prop in source) __hasOwnProp2.call(source, prop) && exclude.indexOf(prop) < 0 && (target[prop] = source[prop]);
    if (source != null && __getOwnPropSymbols2) for (var prop of __getOwnPropSymbols2(source)) exclude.indexOf(prop) < 0 && __propIsEnum2.call(source, prop) && (target[prop] = source[prop]);
    return target;
  },
  ScreenReaderOnly = React.forwardRef((_a, ref) => {
    var _b = _a,
      {
        as = "span",
        children
      } = _b,
      props = __objRest2(_b, ["as", "children"]);
    return React.createElement(Box, __spreadProps2(__spreadValues2({}, props), {
      as,
      border: "none",
      clip: "rect(0 0 0 0)",
      height: "1px",
      margin: "spaceNegative10",
      overflow: "hidden",
      padding: "space0",
      position: "absolute",
      ref,
      textTransform: "none",
      whiteSpace: "nowrap",
      width: "1px"
    }), children);
  });
ScreenReaderOnly.displayName = "ScreenReaderOnly";
import * as React2 from "react";
import { Box as Box2, safelySpreadBoxProps } from "@twilio-paste/box";
import PropTypes from "prop-types";
var ToastVariantObject = {
  ERROR: "error",
  NEUTRAL: "neutral",
  SUCCESS: "success",
  WARNING: "warning"
};
var ToastPropTypes = {
    children: PropTypes.node.isRequired,
    onDismiss: PropTypes.func,
    variant: PropTypes.oneOf(["error", "neutral", "success", "warning"]),
    i18nDismissLabel: PropTypes.string,
    i18nErrorLabel: PropTypes.string,
    i18nNeutralLabel: PropTypes.string,
    i18nSuccessLabel: PropTypes.string,
    i18nWarningLabel: PropTypes.string
  },
  ToastPortalPropTypes = {
    children: PropTypes.node.isRequired,
    __console_patch: PropTypes.bool
  },
  ToastContainerPropTypes = {
    children: PropTypes.node.isRequired,
    __console_patch: PropTypes.bool
  },
  ToasterPropTypes = {
    toasts: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      message: PropTypes.node.isRequired,
      setFocus: PropTypes.bool,
      variant: PropTypes.oneOf(Object.values(ToastVariantObject)).isRequired
    })).isRequired,
    pop: PropTypes.func.isRequired,
    __console_patch: PropTypes.bool
  };
var ErrorToast = React2.forwardRef((_a, ref) => {
  var _b = _a,
    {
      element = "TOAST",
      variant
    } = _b,
    props = __objRest(_b, ["element", "variant"]);
  return React2.createElement(Box2, __spreadProps(__spreadValues({}, safelySpreadBoxProps(props)), {
    ref,
    backgroundColor: "colorBackgroundBody",
    borderColor: "colorBorderWeaker",
    borderRadius: "borderRadius20",
    borderStyle: "solid",
    borderWidth: "borderWidth10",
    borderLeftWidth: "borderWidth30",
    borderLeftColor: "colorBorderErrorWeak",
    boxShadow: "shadowHigh",
    element,
    padding: "space60",
    variant,
    width: "size40"
  }), props.children);
});
ErrorToast.displayName = "ErrorToast";
ErrorToast.propTypes = ToastPropTypes;
import * as React3 from "react";
import { Box as Box3, safelySpreadBoxProps as safelySpreadBoxProps2 } from "@twilio-paste/box";
var NeutralToast = React3.forwardRef((_a, ref) => {
  var _b = _a,
    {
      element = "TOAST",
      variant
    } = _b,
    props = __objRest(_b, ["element", "variant"]);
  return React3.createElement(Box3, __spreadProps(__spreadValues({}, safelySpreadBoxProps2(props)), {
    ref,
    backgroundColor: "colorBackgroundBody",
    borderColor: "colorBorderWeaker",
    borderRadius: "borderRadius20",
    borderStyle: "solid",
    borderWidth: "borderWidth10",
    borderLeftWidth: "borderWidth30",
    borderLeftColor: "colorBorderNeutralWeak",
    boxShadow: "shadowHigh",
    element,
    padding: "space60",
    variant,
    width: "size40"
  }), props.children);
});
NeutralToast.displayName = "NeutralToast";
NeutralToast.propTypes = ToastPropTypes;
import * as React4 from "react";
import { Box as Box4, safelySpreadBoxProps as safelySpreadBoxProps3 } from "@twilio-paste/box";
var SuccessToast = React4.forwardRef((_a, ref) => {
  var _b = _a,
    {
      element = "TOAST",
      variant
    } = _b,
    props = __objRest(_b, ["element", "variant"]);
  return React4.createElement(Box4, __spreadProps(__spreadValues({}, safelySpreadBoxProps3(props)), {
    ref,
    backgroundColor: "colorBackgroundBody",
    borderColor: "colorBorderWeaker",
    borderRadius: "borderRadius20",
    borderStyle: "solid",
    borderWidth: "borderWidth10",
    borderLeftWidth: "borderWidth30",
    borderLeftColor: "colorBorderSuccessWeak",
    boxShadow: "shadowHigh",
    element,
    padding: "space60",
    variant,
    width: "size40"
  }), props.children);
});
SuccessToast.displayName = "SuccessToast";
SuccessToast.propTypes = ToastPropTypes;
import * as React5 from "react";
import { Box as Box5, safelySpreadBoxProps as safelySpreadBoxProps4 } from "@twilio-paste/box";
var WarningToast = React5.forwardRef((_a, ref) => {
  var _b = _a,
    {
      element = "TOAST",
      variant
    } = _b,
    props = __objRest(_b, ["element", "variant"]);
  return React5.createElement(Box5, __spreadProps(__spreadValues({}, safelySpreadBoxProps4(props)), {
    ref,
    backgroundColor: "colorBackgroundBody",
    borderColor: "colorBorderWeaker",
    borderRadius: "borderRadius20",
    borderStyle: "solid",
    borderWidth: "borderWidth10",
    borderLeftWidth: "borderWidth30",
    borderLeftColor: "colorBorderWarningWeak",
    boxShadow: "shadowHigh",
    element,
    padding: "space60",
    variant,
    width: "size40"
  }), props.children);
});
WarningToast.displayName = "WarningToast";
WarningToast.propTypes = ToastPropTypes;
var ToastComponentVariants = {
    error: ErrorToast,
    neutral: NeutralToast,
    success: SuccessToast,
    warning: WarningToast
  },
  renderToastIcon = (variant, title, element) => {
    switch (variant) {
      case ToastVariantObject.ERROR:
        return React6.createElement(ErrorIcon, {
          color: "colorTextIconError",
          decorative: !1,
          title,
          element: `${element}_ICON`,
          size: "sizeIcon20"
        });
      case ToastVariantObject.SUCCESS:
        return React6.createElement(SuccessIcon, {
          color: "colorTextIconSuccess",
          decorative: !1,
          title,
          element: `${element}_ICON`,
          size: "sizeIcon20"
        });
      case ToastVariantObject.WARNING:
        return React6.createElement(WarningIcon, {
          color: "colorTextIconWarning",
          decorative: !1,
          title,
          element: `${element}_ICON`,
          size: "sizeIcon20"
        });
      case ToastVariantObject.NEUTRAL:
      default:
        return React6.createElement(NeutralIcon, {
          color: "colorTextIconNeutral",
          decorative: !1,
          title,
          element: `${element}_ICON`,
          size: "sizeIcon20"
        });
    }
  },
  Toast = React6.forwardRef((_a, ref) => {
    var _b = _a,
      {
        children,
        onDismiss,
        variant = "neutral",
        element = "TOAST",
        setFocus,
        i18nDismissLabel = "Dismiss toast",
        i18nErrorLabel = "(error)",
        i18nNeutralLabel = "(information)",
        i18nSuccessLabel = "(success)",
        i18nWarningLabel = "(warning)"
      } = _b,
      props = __objRest(_b, ["children", "onDismiss", "variant", "element", "setFocus", "i18nDismissLabel", "i18nErrorLabel", "i18nNeutralLabel", "i18nSuccessLabel", "i18nWarningLabel"]);
    let ToastComponent = ToastComponentVariants[variant],
      buttonRef = React6.useRef(null);
    React6.useEffect(() => {
      setFocus && buttonRef.current && buttonRef.current.focus({
        preventScroll: !0
      });
    }, [setFocus]);
    let i18nVariants = {
      error: i18nErrorLabel,
      neutral: i18nNeutralLabel,
      success: i18nSuccessLabel,
      warning: i18nWarningLabel
    };
    return React6.createElement(ToastComponent, __spreadValues({
      role: "status",
      variant,
      element,
      ref
    }, props), React6.createElement(MediaObject, {
      as: "div"
    }, React6.createElement(MediaFigure, {
      as: "div",
      spacing: "space60"
    }, renderToastIcon(variant, i18nVariants[variant], element)), React6.createElement(MediaBody, {
      as: "div"
    }, children), onDismiss && typeof onDismiss == "function" && React6.createElement(MediaFigure, {
      align: "end",
      spacing: "space40"
    }, React6.createElement(Button, {
      onClick: onDismiss,
      variant: "secondary_icon",
      ref: buttonRef,
      size: "reset",
      element: `${element}_CLOSE_BUTTON`
    }, React6.createElement(CloseIcon, {
      decorative: !0,
      size: "sizeIcon20",
      element: `${element}_CLOSE_ICON`
    }), React6.createElement(ScreenReaderOnly, null, i18nDismissLabel)))));
  });
Toast.displayName = "Toast";
Toast.propTypes = ToastPropTypes;
import * as React8 from "react";
import { Stack } from "@twilio-paste/stack";
import * as React7 from "react";
import { StyledBase } from "@twilio-paste/theme";
import { Portal } from "@twilio-paste/reakit-library";
import { Box as Box6, safelySpreadBoxProps as safelySpreadBoxProps5 } from "@twilio-paste/box";
var ToastPortal = React7.forwardRef((_a, ref) => {
  var _b = _a,
    {
      children,
      __console_patch
    } = _b,
    props = __objRest(_b, ["children", "__console_patch"]);
  return React7.createElement(Portal, null, React7.createElement(StyledBase, null, React7.createElement(Box6, __spreadProps(__spreadValues({}, safelySpreadBoxProps5(props)), {
    position: "fixed",
    right: "space40",
    top: "space90",
    zIndex: "zIndex90",
    ref,
    style: __console_patch ? {
      zIndex: 1999
    } : void 0
  }), children)));
});
ToastPortal.displayName = "ToastPortal";
var ToastContainer = React8.forwardRef((_a, ref) => {
  var _b = _a,
    {
      children
    } = _b,
    props = __objRest(_b, ["children"]);
  return React8.createElement(ToastPortal, __spreadValues({}, props), React8.createElement(Stack, {
    orientation: "vertical",
    spacing: "space40",
    ref
  }, children));
});
ToastContainer.displayName = "ToastContainer";
ToastContainer.propTypes = ToastContainerPropTypes;
import * as React9 from "react";
import { useTransition, animated, useReducedMotion } from "@twilio-paste/animation-library";
import { useTheme } from "@twilio-paste/theme";
import { Box as Box7 } from "@twilio-paste/box";
var AnimatedToast = animated(Box7),
  Toaster = _a => {
    var _b = _a,
      {
        toasts,
        pop
      } = _b,
      props = __objRest(_b, ["toasts", "pop"]);
    let prefersReducedMotion = useReducedMotion(),
      [refMap] = React9.useState(() => new WeakMap()),
      [returnTarget, setReturnTarget] = React9.useState({
        trigger: null
      }),
      theme = useTheme(),
      transitions = useTransition(toasts, {
        from: {
          marginBottom: "0rem",
          opacity: 0,
          transform: "translateX(100%) scale(1)",
          height: prefersReducedMotion ? "auto" : 0
        },
        enter: prefersReducedMotion ? {
          marginBottom: theme.space.space40,
          opacity: 1,
          transform: "translateX(0px) scale(1)"
        } : item => async next => {
          await next({
            marginBottom: theme.space.space40,
            opacity: 1,
            transform: "translateX(0px) scale(1)",
            height: refMap.get(item).offsetHeight
          });
        },
        leave: {
          marginBottom: "0rem",
          opacity: 0,
          transform: "translateX(0px) scale(0.8)",
          height: prefersReducedMotion ? "auto" : 0
        },
        config: {
          mass: 1,
          tension: 150,
          friction: 20
        }
      }),
      clearReturnTarget = React9.useCallback(() => {
        setReturnTarget({
          trigger: null
        });
      }, [returnTarget]);
    return React9.useEffect(() => {
      returnTarget.trigger != null && toasts.length === 0 && (returnTarget.trigger.focus(), clearReturnTarget());
    }, [toasts]), React9.createElement(ToastPortal, __spreadValues({}, props), transitions((styles, item, state, index) => React9.createElement(AnimatedToast, {
      as: "div",
      key: state.key,
      style: styles
    }, React9.createElement(Toast, __spreadProps(__spreadValues({
      key: item.id
    }, item), {
      onDismiss: () => {
        item.onDismiss != null && item.onDismiss(), pop(item.id);
      },
      ref: ref => {
        ref != null && refMap.set(item, ref);
      },
      setFocus: index === 0,
      onFocus: e => {
        e.relatedTarget && !returnTarget.trigger && setReturnTarget({
          trigger: e.relatedTarget
        });
      }
    }), item.message))));
  };
Toaster.displayName = "Toaster";
import * as React10 from "react";
import { uid } from "@twilio-paste/uid-library";
var useToaster = () => {
  let isMounted = React10.useRef(null),
    [toasts, setToasts] = React10.useState([]);
  React10.useEffect(() => (isMounted.current = !0, () => {
    isMounted.current = !1, toasts.forEach(toast => {
      toast.timeOutId && window.clearTimeout(toast.timeOutId);
    });
  }), []);
  let pop = id => {
    !isMounted.current || setToasts(currentToasts => currentToasts.filter(toast => (toast.id === id && (toast.timeOutId && window.clearTimeout(toast.timeOutId), toast.onDismiss && toast.onDismiss()), toast.id !== id)));
  };
  return {
    toasts,
    push: newToast => {
      if (!isMounted.current) return;
      let generatedID = uid(newToast),
        timeOutId;
      newToast.dismissAfter != null && Number.isInteger(newToast.dismissAfter) && (timeOutId = window.setTimeout(pop, newToast.dismissAfter, newToast.id || generatedID));
      let existingToasts = toasts.map(toast => {
        let tmpToast = toast;
        return tmpToast.setFocus = !1, tmpToast;
      });
      setToasts([__spreadValues({
        id: generatedID,
        timeOutId,
        setFocus: !0
      }, newToast), ...existingToasts]);
    },
    pop
  };
};
export { AnimatedToast, Toast, ToastContainer, Toaster, useToaster };